import { IIndexable, IModel } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IMajorProgramResponse } from './../../major_explorer_interface';

export interface IMajorActivitySubject extends IIndexable {
  id: number;
  nk: string;
  title: string;
}

export class MajorProgramModel implements IModel {
  in_state_credit_cost: number;
  saved_programs: number[];
  subject: IMajorActivitySubject[];
  activity: IMajorActivitySubject[];

  write(model: IMajorProgramResponse) {
    this.fill(model);
    return this;
  }

  update(model: IMajorProgramResponse): MajorProgramModel {
    this.fill(model);
    return this;
  }

  clear(): MajorProgramModel {
    this.in_state_credit_cost = 0;
    this.saved_programs = [];
    this.subject = [];
    this.activity = [];
    return this;
  }

  read(): MajorProgramModel {
    return this;
  }

  fill(model: IMajorProgramResponse) {
    this.in_state_credit_cost = model.in_state_credit_cost;
    this.saved_programs = !_4.isEmpty(model.saved_programs) ? model.saved_programs : this.saved_programs;
    this.subject = model.subject;
    this.activity = model.activity;
  }
}

angular.module('major-explorer-data').service('ngMajorProgramModel', MajorProgramModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/models/major_program_model.ts